/**
 * Valid statuses for Maytapi phones
 *
 * ⚠️ `blocked` NO es decorativo: `rateLimiter.canSend` lo comprueba **el
 * primero** y corta el envío. Lo pone una persona a mano desde el panel. Que
 * en producción diga `blocked` en 21 de las 22 fichas significa que para el
 * backend hoy solo hay UNA línea capaz de enviar; el motor de WhatsApp manda
 * por las otras porque es un programa aparte que jamás lee esta colección.
 */
const PHONE_STATUSES = ['active', 'deleted', 'blocked'];

/**
 * Default status for newly created phones
 */
const DEFAULT_PHONE_STATUS = 'active';

/**
 * Spanish labels for phone statuses
 */
const PHONE_STATUS_LABELS = {
  active: 'Activo',
  deleted: 'Eliminado',
  blocked: 'Bloqueado',
};

/**
 * Por dónde sale físicamente un mensaje de esta línea.
 *
 * Las dos conviven en la misma colección desde antes de que existiera este
 * campo: el motor de WhatsApp registró sus once líneas como fichas normales
 * —`phone_id` es el nombre de la carpeta del perfil de Chrome: «Persona 1»,
 * «Samsung Azul»…— para poder reutilizar los topes por línea. Nada las
 * distinguía, y por eso el brazo tenía que esquivar comprobaciones que solo
 * tienen sentido para Maytapi.
 *
 * No son intercambiables: una línea de navegador no tiene API, sus envíos son
 * asíncronos —el brazo los recoge cuando pregunta— y su modelo de volumen es
 * el presupuesto que se gana, no el tope fijo.
 */
const PHONE_CHANNELS = ['maytapi', 'navegador'];

/** Con nombre, para no repartir la cadena suelta por el codigo. */
const PHONE_CHANNEL_NAVEGADOR = 'navegador';

/**
 * Maytapi como defecto, y a propósito: es lo que era **toda** ficha antes de
 * que este campo existiera, así que una fila sin migrar se comporta como
 * siempre. Y una línea nueva creada desde el panel sin tocar nada acaba en el
 * canal con topes más conservadores, que es por donde se falla barato.
 */
const DEFAULT_PHONE_CHANNEL = 'maytapi';

/**
 * Spanish labels for phone channels
 */
const PHONE_CHANNEL_LABELS = {
  maytapi: 'Maytapi',
  navegador: 'Navegador',
};

module.exports = {
  PHONE_STATUSES,
  DEFAULT_PHONE_STATUS,
  PHONE_STATUS_LABELS,
  PHONE_CHANNELS,
  PHONE_CHANNEL_NAVEGADOR,
  DEFAULT_PHONE_CHANNEL,
  PHONE_CHANNEL_LABELS,
};
